import {
  getAccreditationFlagTypes,
  getAccreditationType,
  getBindedProcedures,
  getProceduresUnifield,
} from "@/services/electiveSurgeries";
import { ensureDecimalPlaces } from "@/utils/converts";

export default {
  state: {
    accreditation: {},
    types: [],
    accreditationProcedure: {},
    procedures: [],
    accreditationFilters: {},
    bindedProcedure: {},
    proceduresFlagTypes: [],
    proceduresUnifield: [],
  },

  getters: {
    getAccreditation: (state) => state.accreditation,
    getAccreditationType: (state) => state.types,
    getAccreditationProcedure: (state) => state.accreditationProcedure,
    getProceduresData: (state) => state.procedures,
    getAccreditationFilters: (state) => state.accreditationFilters,
    getBindedProcedure: (state) => state.bindedProcedure,
    getProceduresFlagTypes: (state) => state.proceduresFlagTypes,
    getProceduresUnifield: (state) => state.proceduresUnifield,
  },

  mutations: {
    setAccreditation(state, data) {
      const isUpdt = Object.keys(data).length > 0;
      const isDuplicate = data.action === "duplicate";
      const isChange = isUpdt && !isDuplicate;

      state.accreditation = {
        id: isChange ? data.id : null,
        ordinance: isChange ? data.ordinance : "",
        eletive_type_id: isChange ? data.eletive_type_id : null,
        start_date: isChange ? data.start_date : null,
        end_date: isChange ? data.end_date : null,
        procedures: isUpdt ? data.elective_accreditation_procedure : [],
        overall_value: isUpdt ? ensureDecimalPlaces(data.overall_value) : "",
        isUpdt: isUpdt,
        isDuplicate: isDuplicate,
      };
    },

    setAccreditationProcedure(state, data) {
      const isUpdt = Object.keys(data).length > 0;

      state.accreditationProcedure = {
        id: isUpdt ? data.id : null,
        procedure_surgery_eletive_id: isUpdt
          ? data.procedure_surgery_eletive_id
          : null,
        contract_value: isUpdt ? ensureDecimalPlaces(data.contract_value) : "",
        eletive_accreditation_id: state.accreditation.id,
        type_financing_id: isUpdt ? data.type_financing_id : null,
        isUpdt: isUpdt,
      };
    },

    setAccreditationType(state, data) {
      state.types = data;
    },

    setProceduresData(state, data) {
      state.procedures = data;
    },

    setAccreditationFilters(state, filters) {
      state.accreditationFilters = filters;
    },

    setBindedProcedure(state, data) {
      const isUpdt = Object.keys(data).length > 0;

      state.bindedProcedure = {
        id: isUpdt ? data.id : null,
        co_procedure: isUpdt ? data.co_procedure : null,
        name_procedure: isUpdt ? data.name_procedure : null,
        procedures: isUpdt ? data.group_eletive_surgery_procedures : [],
        isUpdt,
      };
    },

    setAccreditationFlagType(state, data) {
      state.proceduresFlagTypes = data;
    },

    setProceduresUnifield(state, data) {
      state.proceduresUnifield = data;
    },
  },

  actions: {
    changeAccreditation(context, data) {
      context.commit("setAccreditation", data);
    },

    async changeAccreditationType(context) {
      const { response } = await getAccreditationType();
      context.commit("setAccreditationType", response);
    },

    changeAccreditationProcedure(context, data) {
      context.commit("setAccreditationProcedure", data);
    },

    async changeProceduresData(context) {
      const { response } = await getBindedProcedures();
      context.commit("setProceduresData", response);
    },

    changeAccreditationFilters(context, filters) {
      context.commit("setAccreditationFilters", filters);
    },

    changeBindedProcedure(context, data) {
      context.commit("setBindedProcedure", data);
    },

    async changeAccreditationFlagType(context) {
      const { response } = await getAccreditationFlagTypes();
      context.commit("setAccreditationFlagType", response);
    },

    async changeProceduresUnifield(context) {
      const { response } = await getProceduresUnifield();
      context.commit("setProceduresUnifield", response);
    },
  },
};
